import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Liste des sociétés ayant des matricules chargés sur la plateforme")
], -1)
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import {onMounted, ref} from "vue";
import DataTable from "primevue/datatable";
import {fetchCompaniesWithUserMatricule} from "@/_services/company/company";
import {ICompanyWithUserMatricule} from "@/models/companyMatricule/ICompanyWithUserMatricule";
import {useCompanyMatriculeStore} from "@/stores/companyMatricule/companyMatriculeStore";
import InputText from "primevue/inputtext";
import Column from "primevue/column";
import Button from "primevue/button";
import { useRouter } from 'vue-router';

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyMatriculeWithUserList',
  setup(__props) {

const router = useRouter();
const store = useCompanyMatriculeStore();
const isLoading = ref<boolean>(true);
const tableData = ref<ICompanyWithUserMatricule[]>([]);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const currentPage = ref<number>(0);
const globalSearch = ref<string>("");
const modeSortable = ref<boolean>(false);
const defaultsSort = {
    fieldLabel: "order[id]",
    fieldValue: "desc",
};

onMounted(async () => {
    if (isLoading.value) {
        showSpinner();
    }
    
    await populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort);
});

const populateDatatable = async (
    itemsPerPage: number,
    page: number,
    globalSearch?:string,
    sort?: { fieldLabel: string; fieldValue: string; },
    filters?: Record<string, string | number>,
) => {
    const [isLoadingDt, totalRecordsDt, tableDataDt] = await fetchCompaniesWithUserMatricule(itemsPerPage, page, globalSearch, sort, filters);
    isLoading.value = isLoadingDt;
    totalRecords.value = totalRecordsDt;
    tableData.value = tableDataDt;
    hideSpinner();
};

const onPaginate = async (e) => {
    rows.value = e.rows;
    showSpinner();
    await populateDatatable(e.rows, e.page + 1, globalSearch.value, defaultsSort);
};

const onGlobalFilterKeyEnter = () => {
    if (globalSearch.value.trim() != "") {
        showSpinner();
        populateDatatable(rows.value, page.value, globalSearch.value);
    }
};

const onGlobalFilterInput = () => {
    if (globalSearch.value === "") {
        showSpinner();
        populateDatatable(rows.value, page.value);
    }
};

const onSort = (e) => {
    showSpinner();
    if (e.sortField) {
        const sort = {
            fieldLabel: "order[" + e.sortField + "]",
            fieldValue: e.sortOrder === 1 ? "asc" : "desc",
        };
        modeSortable.value = true;
        populateDatatable(rows.value, page.value, globalSearch.value, sort);
    } else {
        modeSortable.value = false;
        populateDatatable(rows.value, page.value, globalSearch.value, defaultsSort);
    }
};

const showSpinner = () => {
    isLoading.value = true;
};

const redirectToCompanyMatriculeList = (company: ICompanyWithUserMatricule) => {
    store.setSelectedCompany({
        uuid: company.uuid,
        name: company.name,
    });
    
    router.push({
        name: 'userMatriculesByCompany',
        params: { uuid: company.uuid }
    });
};

const hideSpinner = () => {
    isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        lazy: "",
        removableSort: "",
        paginator: "",
        filterDisplay: "row",
        tableStyle: "min-width: 50rem",
        showGridlines: "",
        stripedRows: "",
        columnResizeMode: "fit",
        value: tableData.value,
        rowHover: true,
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        onPage: onPaginate,
        onSort: _cache[3] || (_cache[3] = ($event: any) => (onSort($event)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(InputText), {
                modelValue: globalSearch.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((globalSearch).value = $event)),
                placeholder: "Rechercher une société",
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onGlobalFilterKeyEnter()), ["enter"])),
                onInput: _cache[2] || (_cache[2] = ($event: any) => (onGlobalFilterInput()))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "id",
            header: "Id Société",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.id), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "name",
            header: "Nom",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "matriculeKeyCie",
            header: "Clé Matricule",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.matriculeKeyCie), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "accountManager",
            header: "Account Manager",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.accountManager), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "walletSc",
            header: "Wallet",
            showFilterMenu: false,
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.walletSc), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
            header: _withCtx(() => [
              _hoisted_6
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Button), {
                onClick: ($event: any) => (redirectToCompanyMatriculeList(slotProps.data)),
                type: "button",
                title: "Voir",
                icon: "pi pi-eye",
                size: "small",
                class: "p-button-eye"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ])
  ], 64))
}
}

})